import React, { useState, useEffect } from "react";
import "../../../styles/QuesPerformance.css";
import axios from "axios";
import { Select, Table, Button, Tooltip } from "antd";
import newStyled from "@emotion/styled";
import { base_url } from "../../../utils/apiConfig";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import { useFetchQueTypes } from "../../../utils/hooks/UseFetchUrl";

const QuesPerformance = () => {
  const [cyclesData, setCyclesData] = useState(null);
  const [quesValue, setQuesValue] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOption1, setSelectedOption1] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [responseData, setResponseData] = useState([]);
  const [storeNames, setStoreNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cycleId, setCycleId] = useState(null);
  const [sectionData, setSectionData] = useState([]);
  const [selectedQueId, setSelectedQueId] = useState(null);
  const [detailsData, setDetailsData] = useState([]);
  const [secQuesData, setSecQuesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const { data: queTypesData } = useFetchQueTypes(
    "/questionnaire_types_for_dashboard",
  );

  useEffect(() => {
    const fetchCycles = async () => {
      if (selectedQueId) {
        try {
          const authToken = localStorage.getItem("authToken");
          const response = await axios.get(
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/questionnaire_types_list/${selectedQueId}/audit_cycle_for_dashboard`, // ✅ use selectedQueId
            {
              headers: {
                Authorization: `token ${authToken}`,
                "Content-Type": "application/json",
              },
            },
          );
          setCyclesData(response.data);
          setDetailsData(response.data);
          setCycleId(null);
        } catch (error) {
          console.error("Error fetching Type of Audit:", error);
        }
      }
    };

    fetchCycles();
  }, [selectedQueId]);
  const [sectionId, setSectionId] = useState(null);

  useEffect(() => {
    if (cyclesData && selectedQueId) {
      const filteredCycles = cyclesData.filter(
        (cycle) => cycle.questionnaire_type.id === selectedQueId,
      );
      setDetailsData(filteredCycles);
      if (filteredCycles.length > 0) {
        setCycleId(filteredCycles[0].id);
      } else {
        setCycleId(null);
      }
    }
  }, [cyclesData, selectedQueId]);

  const handleSelectChange = (value) => {
    const selectedId = parseInt(value, 10);
    setSelectedQueId(selectedId);
    setSelectedOption(selectedId);
  };

  const handleSelectChange1 = async (value) => {
    setSelectedOption1(value);
    setCycleId(value);
    setSelectedSection(null);
    setQuesValue([]);
    setResponseData([]);
    if (value) {
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.get(
          `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_cycle/${value}/section`,
          {
            headers: {
              Authorization: `token ${authToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        setSectionData(response.data);
      } catch (error) {
        console.error("Failed to fetch sections:", error);
      }
    }
  };

  const handleSelectSection = async (value) => {
    setSelectedSection(value);
    setSectionId(value);
    setQuesValue([]);
    setResponseData([]);
    if (value) {
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.get(
          `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/section/${value}/quetions`,
          {
            headers: {
              Authorization: `token ${authToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        setSecQuesData(response.data);
      } catch (error) {
        console.error("Failed to fetch questions:", error);
      }
    }
  };
  const handleQuestionChange = (value) => {
    setQuesValue(value);
  };
  // A table filter only applies to the rows it was made on; drop it when the
  // rows change so Download Report doesn't export stale data.
  useEffect(() => {
    setFilteredData([]);
  }, [responseData]);

  useEffect(() => {
    const fetchData = async () => {
      if (quesValue.length === 0) {
        setResponseData([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      await fetchStoreData(quesValue);
      setLoading(false);
    };

    fetchData();
  }, [quesValue]);

  const COLUMN_WIDTH = "200px";
  const COLUMN_MARKS_WIDTH = "100 !important";
  const MAX_COUNT = 4;

  const getMarksStyle = (text) => {
    const isNA = text === "N/A";

    let marks = 0;
    let maxMarks = 0;

    if (!isNA && text && text.includes("/")) {
      const parts = text.split("/");

      if (parts.length === 2) {
        marks = Number(parts[0].trim());
        maxMarks = Number(parts[1].trim());
      }
    }

    let backgroundColor = "transparent";
    let color = "#000";

    if (isNA || (marks === 0 && maxMarks === 0)) {
      backgroundColor = "transparent";
    } else if (marks === maxMarks) {
      backgroundColor = "#80b918";
      color = "#fff";
    } else if (marks === 0) {
      backgroundColor = "#f27059";
    } else if (marks / maxMarks >= 0.8) {
      backgroundColor = "#ffc300";
    } else if (marks / maxMarks >= 0.6) {
      backgroundColor = "#ffe169";
    } else {
      backgroundColor = "#fdca40";
    }

    return {
      backgroundColor,
      color,
      isNA,
    };
  };

  const dynamicColumns = [
    {
      title: "Store Name",
      dataIndex: "store_name",
      fixed: "left",
      width: "30%",
      className: "custom-padding",
      filters: storeNames,
      filterMode: "tree",
      filterSearch: true,
      onFilter: (value, record) => record.store_id === value,
      onFilterDropdownVisibleChange: (visible) => {
        if (!visible) {
          setTimeout(() => {
            document.querySelector(".ant-table-filter-trigger-clear")?.click();
          }, 100);
        }
      },
    },
    ...quesValue.map((quesId, index) => {
      const question = secQuesData?.find(
        (item) => item.id.toString() === quesId,
      );
      return {
        title: question ? question.name : `Question ${index + 1}`,

        children: [
          {
            title: "Answer Text",
            dataIndex: `question_${index + 1}`,
            className: "custom-ans-padding",
            width: COLUMN_WIDTH,
            render: (text) => {
              if (text === "N/A") {
                return <span>N/A</span>;
              }
              if (!text || typeof text !== "string" || text.trim() === "") {
                return <span>---</span>;
              }
              return <span>{text}</span>;
            },
          },
          {
            title: "Obtain/Max Marks",
            align: "center",
            dataIndex: `marks_${index + 1}`,
            className: "custom-marks-padding",
            render: (text) => {
              const { backgroundColor, color, isNA } = getMarksStyle(text);
              return (
                <div
                  style={{
                    backgroundColor,
                    color,
                    padding: "5px",
                    borderRadius: "4px",
                  }}
                >
                  {/* {text || "N/A"} */}
                  {isNA ? "N/A" : text || "---"}
                </div>
              );
            },
          },
        ],
      };
    }),
  ];

  const fetchStoreData = async (questionIds) => {
    const authToken = localStorage.getItem("authToken");

    try {
      const payload = {
        question_ids: questionIds,
        store_ids: [],
      };

      const response = await axios.post(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/quetions`,
        payload,
        {
          headers: {
            Authorization: `token ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      const groupedStores = {};

      response.data.forEach((item) => {
        const key = `${item.store_details.store_id}_${item.audit_store}`;
        if (!groupedStores[key]) {
          groupedStores[key] = {
            key,
            store_id: item.store_details.store_id,
            store_name: item.store_details.store_name,
          };
        }

        const qIndex = questionIds.findIndex(
          (qid) => qid.toString() === item.question.toString(),
        );

        if (qIndex !== -1) {
          const marks = item.not_applicable ? "N/A" : item.marks_obtained;
          const maxMarks = item.not_applicable ? "N/A" : item.max_marks;

          groupedStores[key][`question_${qIndex + 1}`] =
            item.answer_text || "---";
          groupedStores[key][`marks_${qIndex + 1}`] =
            item.not_applicable || marks === null
              ? "N/A"
              : `${marks} / ${maxMarks}`;
        }
      });

      // Make sure all question columns exist
      const formattedResponse = Object.values(groupedStores).map((store) => {
        questionIds.forEach((_, index) => {
          if (!store[`question_${index + 1}`])
            store[`question_${index + 1}`] = "---";
          if (!store[`marks_${index + 1}`]) store[`marks_${index + 1}`] = "N/A";
        });
        return store;
      });

      const storeNames = formattedResponse.map((item) => ({
        text: item.store_name,
        value: item.store_id,
      }));

      setStoreNames(storeNames);
      setResponseData(formattedResponse);
    } catch (error) {
      console.error("Error fetching store data:", error);
      setResponseData([]);
    }
  };
  const questionOptions =
    secQuesData?.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  const commonBorder = {
    top: {
      style: "thin",
      color: { rgb: "D9D9D9" },
    },
    bottom: {
      style: "thin",
      color: { rgb: "D9D9D9" },
    },
    left: {
      style: "thin",
      color: { rgb: "D9D9D9" },
    },
    right: {
      style: "thin",
      color: { rgb: "D9D9D9" },
    },
  };
  const handleDownloadReport = () => {
    const exportData = filteredData.length > 0 ? filteredData : responseData;

    const worksheetData = [];

    // HEADER ROWS
    const headerRow1 = ["Store Name"];
    const headerRow2 = [""];

    quesValue.forEach((quesId, index) => {
      const question = secQuesData?.find((q) => q.id.toString() === quesId);

      const questionTitle = question ? question.name : `Question ${index + 1}`;

      // Parent header
      headerRow1.push(questionTitle);
      headerRow1.push("");

      // Child header
      headerRow2.push("Answer Text");
      headerRow2.push("Obtain/Max Marks");
    });

    worksheetData.push(headerRow1);
    worksheetData.push(headerRow2);

    // DATA ROWS
    exportData.forEach((item) => {
      const row = [item.store_name];

      quesValue.forEach((_, index) => {
        row.push(item[`question_${index + 1}`] || "---");

        row.push(item[`marks_${index + 1}`] || "N/A");
      });

      worksheetData.push(row);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // MERGES
    worksheet["!merges"] = [
      // Store Name merge
      {
        s: { r: 0, c: 0 },
        e: { r: 1, c: 0 },
      },

      // Question header merges
      ...quesValue.map((_, index) => ({
        s: {
          r: 0,
          c: 1 + index * 2,
        },
        e: {
          r: 0,
          c: 2 + index * 2,
        },
      })),
    ];

    // HEADER STYLING
    for (let row = 0; row <= 1; row++) {
      for (let col = 0; col < headerRow2.length; col++) {
        const cellRef = XLSX.utils.encode_cell({
          r: row,
          c: col,
        });

        if (worksheet[cellRef]) {
          worksheet[cellRef].s = {
            font: {
              bold: true,
              color: { rgb: "000000" },
              sz: 12,
            },

            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },

            fill: {
              fgColor: { rgb: "FFFFFF" },
            },

            border: commonBorder,
          };
        }
      }
    }

    // DATA CELL STYLING
    exportData.forEach((item, rowIndex) => {
      quesValue.forEach((_, qIndex) => {
        const marksValue = item[`marks_${qIndex + 1}`];

        // because 2 header rows exist
        const excelRow = rowIndex + 2;

        // marks column positions
        const marksCol = 2 + qIndex * 2;

        const cellRef = XLSX.utils.encode_cell({
          r: excelRow,
          c: marksCol,
        });

        const { backgroundColor, color } = getMarksStyle(marksValue);

        const bgColor =
          backgroundColor === "transparent"
            ? "FFFFFF"
            : backgroundColor.replace("#", "");

        if (worksheet[cellRef]) {
          worksheet[cellRef].s = {
            fill: {
              fgColor: { rgb: bgColor },
            },

            font: {
              color: { rgb: "000000" },
              bold: true,
            },

            alignment: {
              horizontal: "center",
              vertical: "center",
            },

            border: commonBorder,
          };
        }
      });
    });

    // COLUMN WIDTHS
    worksheet["!cols"] = [
      { wch: 40 },

      ...quesValue.flatMap(() => [{ wch: 45 }, { wch: 20 }]),
    ];

    // ROW HEIGHTS
    worksheet["!rows"] = [{ hpt: 90 }, { hpt: 28 }];

    // CREATE WORKBOOK
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Question Performance");

    XLSX.writeFile(workbook, "Question_Performance_Report.xlsx");
  };
  return (
    <div className="main-container-si">
      <div className="npsHead">
        <div className="npsParaHead">
          <p className="">Question Wise Performance</p>{" "}
        </div>
        <button className="download-report-btn" onClick={handleDownloadReport}>
          <Tooltip title="Export List">
            <VerticalAlignBottomOutlined className="exportIconAT" />
          </Tooltip>
          Download Report
        </button>
      </div>
      <div className="step-ai">
        Step 1: Select the Questionnaire Type → Step 2: Select the Type of Audit
        → Step 3: Select the Section → Step 4: Select up to 3 Questions
      </div>
      <div className="step-ai">
        After completing the steps above, you will be able to view question-wise
        performance for each store.
      </div>
      <div className="head-qp d-flex align-items-center justify-content-between flex-wrap mt-3">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <p className="AtQuesHeading">Questionnaire Type:</p>
            <SelectStyle
              value={selectedOption}
              onChange={handleSelectChange}
              className="at-select"
              placeholder="Select Questionnaire Type"
              allowClear
              style={{ width: 220 }}
              dropdownStyle={{ maxWidth: 300 }}
            >
              {queTypesData?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </SelectStyle>
          </div>
          <div className="d-flex align-items-center gap-2">
            <p className="RbQuesHeading">Type of Audit:</p>
            <SelectStyle
              value={selectedOption1}
              onChange={handleSelectChange1}
              className="auditCycleAT"
              placeholder="Select Type of Audit"
              allowClear
              style={{ width: 220 }}
              dropdownStyle={{ maxWidth: 300 }}
            >
              {detailsData?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </SelectStyle>
          </div>
          <div className="d-flex align-items-center gap-2">
            <p className="RbQuesHeading">Section:</p>
            <SelectStyle
              value={selectedSection}
              onChange={handleSelectSection}
              className="auditCycleAT"
              placeholder="Select Section"
              allowClear
              style={{ width: 220 }}
              dropdownStyle={{ maxWidth: 300 }}
            >
              {sectionData?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </SelectStyle>
          </div>
          <div className="d-flex align-items-center gap-2">
            <p className="AtQuesHeading">Questions:</p>
            <SelectStyle
              mode="multiple"
              value={quesValue}
              onChange={handleQuestionChange}
              placeholder="Please select"
              maxTagCount={0}
              style={{ minWidth: 220, flex: 1, cursor: "pointer" }}
              maxCount={MAX_COUNT}
              allowClear
              dropdownStyle={{ maxWidth: 300 }}
            >
              {questionOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </SelectStyle>
          </div>
        </div>
      </div>
      <TableStyle
        columns={quesValue.length > 0 ? dynamicColumns : []}
        dataSource={quesValue.length > 0 ? responseData : []}
        loading={loading}
        pagination={false}
        scroll={{ x: "max-content" }}
        onChange={(pagination, filters, sorter, extra) => {
          setFilteredData(extra.currentDataSource);
        }}
        locale={{
          emptyText: (
            <div
              style={{
                padding: "40px",
                textAlign: "center",
                color: "#888",
                backgroundColor: "#fff",
                fontSize: "16px",
              }}
            >
              Please, select above options
            </div>
          ),
        }}
      />
    </div>
  );
};
const SelectStyle = newStyled(Select)`
  .ant-select-selector {
    cursor: pointer !important;
  }
    .at-select .ant-select-selector {
    // border: none !important;
    border-bottom: 2px solid #d9d9d9 !important;
    border-top: 0px solid #fff !important;
    border-right: 0px solid #fff !important;
    border-left: 0px solid #fff !important;
    border-radius: 0;
    box-shadow: none;
  }

  .at-select .ant-select-selector:focus,
  .at-select .ant-select-selector:hover {
    border-bottom: 2px solid #1890ff !important;
  }

  :where(.css-dev-only-do-not-override-1kf000u).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
//  border:none !important;
  border-bottom: 2px solid rgb(58, 56, 56) !important;
    border-top: 0px solid #fff !important;
    border-right: 0px solid #fff !important;
    border-left: 0px solid #fff !important;
  border-radius: 3px !important;
 box-shadow:none !important;
 }
 :where(.css-dev-only-do-not-override-1kf000u).ant-select-single {
   height:22px !important;
   margin-bottom: 0.5rem !important;
 }

 :where(.css-1kf000u).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector{
   border-bottom: 2px solid rgb(58, 56, 56) !important;
  border-radius: 3px !important;
 box-shadow:none !important;
//  border:none !important;
 }
`;
const ButtonStyleQues = newStyled(Button)`
:where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-solid {
background-color: #007DC1 !important;
    color: #ffffff !important;
    font-family: 'Roboto',sans-serif  !important;
    font-size: 1rem  !important;
    padding: 0 1rem !important;
}
`;

const TableStyle = newStyled(Table)`
margin-top:4rem !important;
 .ant-table-tbody > tr:nth-child(odd) {
    background-color: rgb(242, 242, 242) !important;
  }

  .ant-table-tbody > tr:nth-child(even) {
    background-color: #ffffff !important;
    transition: background-color 0.3s ease;
  }

  .ant-table-tbody > tr:nth-child(even):hover {
    background-color: rgb(242, 242, 242) !important;
  }
    .ant-table-tbody > tr:nth-child(odd):hover {
    background-color: rgb(242, 242, 242) !important;
  }
  .ant-table {
  border-collapse: collapse;
}

.ant-table-thead > tr > th, 
{
  border-bottom: none !important;
}

.ant-table-thead > tr + tr > th {
  border-top: 1px solid #f0f0f0;
}

:where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>th,{
text-align: center !important;
}
  
`;

export default QuesPerformance;
